import React from 'react';
import { Grid, Typography, Button } from "@material-ui/core";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import '../../App.css'
import './studyStyles.css'
import { ThemeProvider } from '@material-ui/styles';
import Container from '@material-ui/core/Container';
import theme from '../../theme';
import globalUseStyles from '../../styleHooks';

function StudySolution() {
  const globalClasses = globalUseStyles()
  return (
    <ThemeProvider theme={theme}>
      <Container className={"studySolutionsStyle"} maxWidth={false} component="section">
          <Grid className={globalClasses.containerVertPaddingLg} container>
            <Grid className={globalClasses.containerSmall} container>
                <Grid item xs={12} md={3}  >
                  <Typography variant="subtitle1">Results</Typography>
                  <Typography variant="h2">The Solution</Typography>
                </Grid>
                <Grid item xs={false} md={1} />
                <Grid item xs={12} md={8}  >
                  <Typography variant="body1">The end result is a comprehensive case and caregiver management system to document and report on the caregiver experience with RCI, across all programs and touchpoints. This solution includes a web app to support the workflow of individual programs, as well as ways to collect data about caregivers outside of a specific program. We created an assessment management system within Survey JS where clients can create new assessments or modify existing ones in a self-service manner. Lastly, our robust reporting and data analytics, set up through Tableau, helped RCI understand the incoming data and make strategic decisions for future enhancements to the application, programs, and organization at large. </Typography>
                  <List>
                      <ListItem>
                        <ListItemText classes={{primary:globalClasses.listItemText}}>- Case Management Web Application</ListItemText>
                      </ListItem>
                      <ListItem>
                        <ListItemText classes={{primary:globalClasses.listItemText}}>- Self-Service Survey and Assessment Management</ListItemText>
                      </ListItem>
                      <ListItem>
                        <ListItemText classes={{primary:globalClasses.listItemText}}>- Reporting and Dashboards </ListItemText>
                      </ListItem>
                  </List>
                  <Button className={'secondaryButton'} variant="outlined" color="inherit">View Final Product</Button>
                </Grid>
            </Grid>
          </Grid>
      </Container>
    </ThemeProvider>
  );
};

export default StudySolution;